import { code } from "@spscommerce/utils";

export const SpsTooltipExamples = {
  positioning: {
    label: "Positioning",
    examples: {
      topLeft: {
        template: code`
                <div id="tooltip-target-top-left" class="greybox">
                  Position: top left
                </div>
                <sps-tooltip for="tooltip-target-top-left"
                title="Title" position="top left">
                  Tooltip content
                </sps-tooltip>
            `},
      topMiddle: {
        template: code`
                <div id="tooltip-target-top-middle" class="greybox">
                  Position: top middle (default; position attribute
                  not technically necessary here)
                </div>
                <sps-tooltip for="tooltip-target-top-middle"
                title="Title" position="top middle">
                  Tooltip content
                </sps-tooltip>
            `},
      topRight: {
        template: code`
                <div id="tooltip-target-top-right" class="greybox">
                  Position: top right
                </div>
                <sps-tooltip for="tooltip-target-top-right"
                title="Title" position="top right">
                  Tooltip content
                </sps-tooltip>
            `},
      rightTop: {
        template: code`
                <div id="tooltip-target-right-top" class="greybox">
                  Position: right top
                </div>
                <sps-tooltip for="tooltip-target-right-top"
                title="Title" position="right top">
                  Tooltip content
                </sps-tooltip>
            `},
      rightMiddle: {
        template: code`
                <div id="tooltip-target-right-middle" class="greybox">
                  Position: right middle
                </div>
                <sps-tooltip for="tooltip-target-right-middle"
                title="Title" position="right middle">
                  Tooltip content
                </sps-tooltip>
            `},
      rightBottom: {
        template: code`
                <div id="tooltip-target-right-bottom" class="greybox">
                  Position: right bottom
                </div>
                <sps-tooltip for="tooltip-target-right-bottom"
                title="Title" position="right bottom">
                  Tooltip content
                </sps-tooltip>
            `},
      bottomRight: {
        template: code`
                <div id="tooltip-target-bottom-right" class="greybox">
                  Position: bottom right
                </div>
                <sps-tooltip for="tooltip-target-bottom-right"
                title="Title" position="bottom right">
                  Tooltip content
                </sps-tooltip>
            `},
      bottomMiddle: {
        template: code`
                <div id="tooltip-target-bottom-middle" class="greybox">
                  Position: bottom middle
                </div>
                <sps-tooltip for="tooltip-target-bottom-middle"
                title="Title" position="bottom middle">
                  Tooltip content
                </sps-tooltip>
            `},
      bottomLeft: {
        template: code`
                <div id="tooltip-target-bottom-left" class="greybox">
                  Position: bottom left
                </div>
                <sps-tooltip for="tooltip-target-bottom-left"
                title="Title" position="bottom left">
                  Tooltip content
                </sps-tooltip>
            `},
      leftBottom: {
        template: code`
                <div id="tooltip-target-left-bottom" class="greybox">
                  Position: left bottom
                </div>
                <sps-tooltip for="tooltip-target-left-bottom"
                title="Title" position="left bottom">
                  Tooltip content
                </sps-tooltip>
            `},
      leftMiddle: {
        template: code`
                <div id="tooltip-target-left-middle" class="greybox">
                  Position: left middle
                </div>
                <sps-tooltip for="tooltip-target-left-middle"
                title="Title" position="left middle">
                  Tooltip content
                </sps-tooltip>
            `},
      leftTop: {
        template: code`
                <div id="tooltip-target-left-top" class="greybox">
                  Position: left top
                </div>
                <sps-tooltip for="tooltip-target-left-top"
                title="Title" position="left top">
                  Tooltip content
                </sps-tooltip>
            `}
    }
  },
  style: {
    label: "Tooltip Styles",
    examples: {
      help: {
        template: code`
                <div id="tooltip-target-help" class="greybox">
                  "help" style tooltip
                </div>
                <sps-tooltip for="tooltip-target-help"
                title="Title" kind="help">
                  Tooltip content
                </sps-tooltip>
            `},
      error: {
        template: code`
                <div id="tooltip-target-error" class="greybox">
                  "error" style tooltip
                </div>
                <sps-tooltip for="tooltip-target-error"
                title="Title" kind="error">
                  Tooltip content
                </sps-tooltip>
            `},
      warning: {
        template: code`
                <div id="tooltip-target-warning" class="greybox">
                  "warning" style tooltip
                </div>
                <sps-tooltip for="tooltip-target-warning"
                title="Title" kind="warning">
                  Tooltip content
                </sps-tooltip>
            `},
      container: {
        template: code`
                <div id="tooltip-target-container" class="greybox">
                  "container" style tooltip
                </div>
                <sps-tooltip for="tooltip-target-container"
                title="Title" kind="container">
                  Tooltip content
                </sps-tooltip>
            `}
    }
  },
  offsets: {
    label: "Custom positioning offsets",
    examples: {
      offsets: {
        template: code`
            <div id="tooltip-target-offsets" class="greybox">
              Tooltip with positioning offsets 0, -100
              (default is 13, 0)
            </div>
            <sps-tooltip for="tooltip-target-offsets"
            title="Title" offsets="0, -100">
              Tooltip content
            </sps-tooltip>
        `}
    }
  },
  hideDelay: {
    label: "Custom Hide Delay",
    examples: {
      hideDelay: {
        template: code`
            <div id="tooltip-target-hide-delay" class="greybox">
              Tooltip will hide as soon as mouse leaves
              the area, since hideDelay is 0 (default is 1000ms)
            </div>
            <sps-tooltip for="tooltip-target-hide-delay"
            title="Title" hideDelay="0">
              Tooltip content
            </sps-tooltip>
        `}
    }
  },
  onClick: {
    label: "Toggle on click",
    examples: {
      onClick: {
        template: code`
            <div id="tooltip-target-on-click" class="greybox">
              You have to click this element to show the tooltip
              and to hide it again.
            </div>
            <sps-tooltip for="tooltip-target-on-click"
            title="Title" showOn="click">
              Tooltip content
            </sps-tooltip>
        `}
    }
  }
};

